import React, { useState, useEffect } from 'react'
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);
  const [username, setusername] = useState("");
  const [role, setrole] = useState("");

  // Track which submenu is open
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
      fetchData1(user);
    });
  }, []);

  const fetchData1 = async (user) => {
    try {
      if (user) {
        if (loadincount) {
          const docRef = doc(db, "users", user.uid)
          const docSnap = await getDoc(docRef)
          if (docSnap.exists()) {
            setrole(docSnap.data().role);
            setusername(docSnap.data().username);
            setloadincount(false)
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand Logo */}
      <a href="/home" className="brand-link">
        <img
          src={window.location.origin + '/user.jpg'}
          alt="A"
          className="brand-image img-circle elevation-3"
          style={{ opacity: '.8' }}
        />
        <span className="brand-text font-weight-light">{username}</span>
      </a>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">

            {/* HOME */}
            <li className="nav-item">
              <a href="/home" className="nav-link">
                <i className="nav-icon fa fa-home" />
                <p>Home</p>
              </a>
            </li>

            {/* AVAK REGISTER */}
            <li className={`nav-item ${openMenu === "avak" ? "menu-open" : ""}`}>
              <a
                href="#"
                className={`nav-link ${openMenu === "avak" ? "active" : ""}`}
                onClick={() => toggleMenu("avak")}
              >
                <i className="nav-icon fa fa-book" />
                <p>
                  Avak Register
                  <i className="fa fa-angle-left right"></i>
                </p>
              </a>
              <ul
                className="nav nav-treeview"
                style={{ display: openMenu === "avak" ? "block" : "none" }}
              >
                <li className="nav-item">
                  <a href="/avak-register" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Add Avak Data</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/view-avak-data" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>View Avak Data</p>
                  </a>
                </li>
              </ul>
            </li>

            {/* JAVAK REGISTER */}
            <li className={`nav-item ${openMenu === "javak" ? "menu-open" : ""}`}>
              <a
                href="#"
                className={`nav-link ${openMenu === "javak" ? "active" : ""}`}
                onClick={() => toggleMenu("javak")}
              >
                <i className="nav-icon fa fa-book" />
                <p>
                  Javak Register
                  <i className="fa fa-angle-left right"></i>
                </p>
              </a>
              <ul
                className="nav nav-treeview"
                style={{ display: openMenu === "javak" ? "block" : "none" }}
              >
                <li className="nav-item">
                  <a href="/javak-data" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Javak Register</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/view-javak-data" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>View Javak Data</p>
                  </a>
                </li>
              </ul>
            </li>

            {/* BILL PAYMENTS */}
            <li className={`nav-item ${openMenu === "bill" ? "menu-open" : ""}`}>
              <a
                href="#"
                className={`nav-link ${openMenu === "bill" ? "active" : ""}`}
                onClick={() => toggleMenu("bill")}
              >
                <i className="nav-icon fa fa-money" />
                <p>
                  Bill Payments
                  <i className="fa fa-angle-left right"></i>
                </p>
              </a>
              <ul
                className="nav nav-treeview"
                style={{ display: openMenu === "bill" ? "block" : "none" }}
              >
                <li className="nav-item">
                  <a href="/purchase-orders" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Purchase Orders</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/requisitions" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Requisitions</p>
                  </a>
                </li>
              </ul>
            </li>

            {/* REPORTS */}
            <li className={`nav-item ${openMenu === "report" ? "menu-open" : ""}`}>
              <a
                href="#"
                className={`nav-link ${openMenu === "report" ? "active" : ""}`}
                onClick={() => toggleMenu("report")}
              >
                <i className="nav-icon fa fa-file" />
                <p>
                  Reports
                  <i className="fa fa-angle-left right"></i>
                </p>
              </a>
              <ul
                className="nav nav-treeview"
                style={{ display: openMenu === "report" ? "block" : "none" }}
              >
                <li className="nav-item">
                  <a href="/productwise-ledger" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Product Wise Ledger</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/avak-javak-report" className="nav-link">
                    <i className="fa fa-circle-o nav-icon"></i>
                    <p>Avak Javak Report</p>
                  </a>
                </li>
              </ul>
            </li>

            {/* STORE LEDGER */}
            <li className="nav-item">
              <a href="/store-ledger" className="nav-link">
                <i className="nav-icon fa fa-television" />
                <p>Store Ledger</p>
              </a>
            </li>

            {/* DEPARTMENTS */}
            <li className="nav-item">
              <a href="/departments" className="nav-link">
                <i className="nav-icon fa fa-indent" />
                <p>Department</p>
              </a>
            </li>

            {/* PRODUCTS */}
            <li className="nav-item">
              <a href="/products" className="nav-link">
                <i className="nav-icon fa fa-list-ul" />
                <p>Products</p>
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </aside>
  )
}

export default Menu
